import script from "./[classId].vue?vue&type=script&setup=true&lang=ts"
export * from "./[classId].vue?vue&type=script&setup=true&lang=ts"

import "./[classId].vue?vue&type=style&index=0&id=3e3f36c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e3f36c6"]])

export default __exports__